import { ThemeProvider } from "styled-components";
import { useEffect, useState } from "react";
import { darkTheme } from "./utils/Themes.js";
import Navbar from "./components/Navbar";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import HeroSection from "./components/HeroSection";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Experience from "./components/Experience";
import Education from "./components/Education";
import ProjectDetails from "./components/ProjectDetails";
import Cursor from "./components/Cursor";
import ScrollProgress from "./components/ScrollProgress";
import { AnimatePresence } from "framer-motion";
import styled from "styled-components";

const Body = styled.div`
  background-color: ${({ theme }) => theme.bg};
  width: 100%;
  overflow-x: hidden;
`;

function App() {
  const [openModal, setOpenModal] = useState({ state: false, project: null });

  useEffect(() => {
    if (!window.location.hash) return;
    const id = window.location.hash.slice(1);
    const timer = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "auto" });
    }, 120);
    return () => clearTimeout(timer);
  }, []);

  return (
    <ThemeProvider theme={darkTheme}>
      <Router>
        <ScrollProgress />
        <Cursor />
        <Navbar />
        <Body>
          <HeroSection />
          <About />
          <Experience />
          <Skills />
          <Projects openModal={openModal} setOpenModal={setOpenModal} />
          <Education />
          <Contact />
          <Footer />
          <AnimatePresence>
            {openModal.state && (
              <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
            )}
          </AnimatePresence>
        </Body>
      </Router>
    </ThemeProvider>
  );
}

export default App;
